import { createError, defineNuxtRouteMiddleware } from '#imports'

import { useBuybackEnabled } from '../composables/useBuybackEnabled/useBuybackEnabled'

export default defineNuxtRouteMiddleware(() => {
  const { isBuybackCmsPagesEnabled } = useBuybackEnabled()

  if (!isBuybackCmsPagesEnabled) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Buyback CMS pages are not enabled for this market',
      fatal: true,
    })
  }
})
